<template>
  <div class="tab-container">
    <b-tabs type="is-boxed" size="is-small">
      <!-- アイコンの設定モーダル -->
      <b-modal width="400px" :active.sync="iconSelectFlg">
        <div class="card" style="border-radius: 5px;">
          <header class="card-header">
            <p class="card-header-title title" style="font-size: 24px;">
              アイコンテンプレート
            </p>
          </header>
          <div class="card-content">
            <div class="select-icon-wrapper">
              <button
                @click="color.template=(i == 10 ? 0 : i);iconSelectFlg=false"
                class="button"
                style="border-radius: 0; height: 60px; width: 60px; border-radius: 50%; margin: 5px; padding: 0;"
                v-for="(i, index) in 45"
                :style="makeIconSelect()"
                :value="index"
                :key="index">
                <span :class="getIcon(i - 1)"></span>
              </button>
            </div>
          </div>
        </div>
      </b-modal>
      <!-- タブ１：　アプリの追加 -->
      <b-tab-item>
        <template slot="header" class="header">
            <span class="mdi mdi-power-standby mdi-24px" style="margin-left:5px;"></span>
            <span> アプリ の追加 </span>
        </template>
        <div class="block-container disp-scroll">
          <div class="card-add-tab">
            <header class="card-header">
              <div class="card-header-title">
                HRモンスター | アプリ の追加
              </div>
            </header>
            <div class="media-content" style="padding: 15px;">
              <p>HTML の一番下、他のスクリプトタグの前に、以下のスニペットをコピーして貼り付けてください。</p>
            </div>
            <div class="card-content" style="background: #FEFEFE; word-wrap: break-word;">
              <div class="content snippets">
                {{ snippets }}
              </div>
            </div>
            <footer class="card-footer">
              <a class="card-footer-item copy-btn" @click="clipcopy">COPY</a>
              <div class="field card-footer-item" v-if="user.permission===0">
                <b-switch id="AS-0001" :value="power === 1"
                  @input="changeSwitch()"
                  type="is-primary">
                  アプリアイコン On/Off
                </b-switch>
              </div>
            </footer>
            <input type="hidden" id="copy-code" :value="snippets">
          </div>
        </div>
      </b-tab-item>
      <!-- タブ２：　設置アイコンの設定 -->
      <b-tab-item>
        <template slot="header" class="header">
            <span class="mdi mdi-settings-outline mdi-24px" style="margin-left:5px;"></span>
            <span> アプリ 設置アイコンの設定 </span>
        </template>
        <div class="block-container -icon-setting disp-scroll">
          <div class="card-setting-tab">
            <header class="card-header">
              <div class="card-header-title">
                HRモンスター | アプリ 設置アイコンの設定
              </div>
            </header>
            <div class="card-content -icon-setting">
              <article class="icon-demo-container">
                <div class="icon-demo-wrapper disp-scroll">
                  <div class="icon-demo">
                    <div class="icon-style -ballon" style="margin-bottom: 8px;">
                      <div class="icon list-msg"
                        :style="{
                          'background-color': color.iconBallon,
                          'filter': shadowStyle()
                        }">
                        <div class="new-msg-log"
                          :style="{'color': color.iconMsg}" v-if="color.customMsg=='' || color.template != 10">
                          ここにメッセージが
                          入ります。
                        </div>
                        <span class="message-icon" v-if="color.template == 10" :style="{'color': color.iconMsg}">{{color.customMsg}}</span>
                      </div>
                    </div>
                    <div class="icon-style">
                      <!-- ボタンエフェクト -->
                      <span class="back-ring"
                            id="changeButtonBack"
                            v-if="color.animationType==1"
                            :style="{
                              'background': color.iconBg + '!important',
                              'border-radius': color.iconRadius,
                              'height': color.iconHeight,
                              'width': color.iconWidth,
                              }">
                      </span>
                      <a class="icon bot-icon"
                          :style="{
                            'background-color': color.iconBg,
                            color: color.iconFr,
                            'height': color.iconHeight,
                            'width': color.iconWidth,
                            'border-radius': color.iconRadius,
                            'filter': shadowStyle(),
                            'margin-right': (color.showMinimizeButton ? '25px' : '0px')
                          }"
                          :class="getIcon(color.template - 1) + ' ' +  getAnimation(color.animationType)"
                      >
                        <img :style="{
                          'height': color.iconHeight,
                          'width': color.iconWidth,
                          'border-radius': color.iconRadius,
                        }" :src="color.iconImage" v-if="color.template===10&&!isLoading">
                        <div
                        class="custom-icon-message"
                        :class="{
                          'left-4px': color.customMsg !='' && color.template != 10,
                          '-custom-true': color.template == 10
                          }"
                        :style="{'border-radius': color.iconRadius,}"
                        >
                          <span v-if="color.template != 10">{{color.customMsg}}</span>
                        </div>
                      </a>
                      <div class="minimize-button" v-if="color.showMinimizeButton">
                        <span class="mdi mdi-minus-circle-outline mdi-24px" :style="'color:' + color.iconBg"></span>
                      </div>
                    </div>
                  </div>
                  <div class="right-balloon-wrapper">
                    <div class="balloon"
                          :style="{'background-color': color.balloonMy,
                          'color': autoColor(color.balloonMy),
                          'filter': shadowStyle()}"
                    >
                    訪問者側（右）の
                    吹き出しです。
                    </div>
                  </div>
                  <div class="left-balloon-wrapper">
                    <div class="balloon"
                          :style="{'background-color': color.balloonOtr,
                                  'color': autoColor(color.balloonOtr),
                                  'filter': shadowStyle()}"
                          style="color:black"
                    >
                    管理者側（左）の
                    吹き出しです。
                    </div>
                  </div>
                </div>
              </article>
              <article class="setting-article disp-scroll">
                <section>
                  <p><b>アイコン・吹き出しの設定</b></p>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <button style="margin-top: 20px;" class="button icon-select-btn" @click="iconSelectFlg=true" expanded>アイコンの変更</button>
                    </div>
                    <div class="column">
                      <label for="file_upload" class="icon-modify">
                        <a class="button">画像の設定</a>
                        <input ref="imageUploader" type="file" id="file_upload" @change="onFileChange">
                      </label>
                    </div>
                    <div class="column">
                      <span>アイコンの形</span>
                      <b-select placeholder="種類を選択"
                                v-model="color.shapeType"
                                expanded>
                          <option
                              v-for="(i, index) in shapeName"
                              :value="index"
                              :key="index">
                              {{ i }}
                          </option>
                      </b-select>
                    </div>
                  </div>
                  <div class="custom-columns columns is-mobile is-centered" v-if="color.shapeType == 2">
                    <div class="column">
                      <span>アイコンメッセージ</span>
                      <textarea class="textarea" type="text" v-model="color.customMsg" maxlength='100'></textarea>
                    </div>
                    <div class="column">
                      <span>アイコンの横幅</span><span></span>
                      <b-field style="flex-wrap: wrap;">
                        <input class="slider" type="range" max="260" min="60" step="10" list="a" v-model="iconWidth"/>
                        <div style="display: flex; justify-content: space-between; width: 100%;">
                          <p>小</p>
                          <p>中</p>
                          <p>大</p>
                        </div>
                      </b-field>
                    </div>
                    <div class="column">
                      <span>アイコンの縦幅</span><span></span>
                      <b-field style="flex-wrap: wrap;">
                        <input class="slider" type="range" max="260" min="60" step="10" v-model="iconHeight"/>
                        <div style="display: flex; justify-content: space-between; width: 100%;">
                          <p>小</p>
                          <p>中</p>
                          <p>大</p>
                        </div>
                      </b-field>
                    </div>
                    <div class="column">
                      <span>アイコンの丸み</span>
                      <b-field style="flex-wrap: wrap;">
                        <input class="slider" type="range" max="130" min="0" step="2" v-model="iconRadius"/>
                        <div style="display: flex; justify-content: space-between; width: 100%;">
                          <p>角</p>
                          <p></p>
                          <p>丸</p>
                        </div>
                      </b-field>
                    </div>
                  </div>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <span>アイコンの背景色</span>
                      <b-field>
                        <input class="input" type="text" placeholder="アイコンの背景色" v-model="color.iconBg">
                        <input style="height: 35px;" type="color" v-model="color.iconBg"/>
                      </b-field>
                    </div>
                    <div class="column">
                      <span>アイコン<span v-if="color.template == 10">内のメッセージ</span>の色</span>
                      <b-field>
                        <input style="border: solid thin #ccc;" class="input" type="text" placeholder="アイコンの色" v-model="color.iconFr">
                        <input style="height: 35px;" type="color" v-model="color.iconFr"/>
                      </b-field>
                    </div>
                  </div>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <span>アニメーション設定</span>
                      <b-select placeholder="種類を選択"
                                v-model="color.animationType"
                                expanded>
                          <option
                              v-for="(i, index) in animationType"
                              :value="index"
                              :key="index">
                              {{ i }}
                          </option>
                      </b-select>
                    </div>
                    <div class="column">
                      <span>影の設定</span>
                      <b-select placeholder="影を選択"
                                v-model="color.shadowType"
                                expanded>
                          <option
                              v-for="(i, index) in shadowName"
                              :value="index"
                              :key="index">
                              {{ i }}
                          </option>
                      </b-select>
                    </div>
                  </div>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <span>アイコン上の吹き出しの色</span>
                      <b-field>
                        <input style="border: solid thin #ccc;" class="input" type="text" placeholder="吹き出しの色" v-model="color.iconBallon">
                        <input style="height: 35px;" type="color" v-model="color.iconBallon" />
                      </b-field>
                    </div>
                    <div class="column">
                      <span>アイコン上の吹き出しの文字の色</span>
                      <b-field>
                        <input style="border: solid thin #ccc;" class="input" type="text" placeholder="吹き出しの色" v-model="color.iconMsg">
                        <input style="height: 35px;" type="color" v-model="color.iconMsg" />
                      </b-field>
                    </div>
                  </div>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <span>訪問者側（右）の吹き出しの色</span>
                      <b-field>
                        <input class="input" type="text" placeholder="訪問者側（右）の吹き出しの色" v-model="color.balloonMy">
                        <input style="height: 35px;" type="color" v-model="color.balloonMy"/>
                      </b-field>
                    </div>
                    <div class="column">
                      <span>管理者側（左）の吹き出しの色</span>
                      <b-field>
                        <input class="input" type="text" placeholder="管理者側（左）の吹き出しの色" v-model="color.balloonOtr">
                        <input style="height: 35px;" type="color" v-model="color.balloonOtr"/>
                      </b-field>
                    </div>
                  </div>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <span>アイコン最小化ボタンの表示</span>
                      <b-select v-model="color.showMinimizeButton"
                                expanded>
                          <option
                              v-for="(st, index) in showStates"
                              :value="st.label"
                              :key="index">
                              {{ st.name }}
                          </option>
                      </b-select>
                    </div>
                    <div class="column">
                    </div>
                  </div>
                </section>
                <section>
                  <p><b>PC設定</b></p>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <span>アプリ　設置アイコンの基準位置（縦）</span>
                      <b-select placeholder="位置を選択"
                                v-model="color.pc_vertical_position"
                                expanded>
                          <option
                              v-for="(pos, index) in verticalPositions"
                              :value="pos.label"
                              :key="index">
                              {{ pos.name }}
                          </option>
                      </b-select>
                    </div>
                    <div class="column">
                      <span>アプリ　設置アイコンの基準位置（横）</span>
                      <b-select placeholder="位置を選択"
                                v-model="color.pc_horizontal_position"
                                expanded>
                          <option
                              v-for="(pos, index) in horizontalPositions"
                              :value="pos.label"
                              :key="index">
                              {{ pos.name }}
                          </option>
                      </b-select>
                    </div>
                  </div>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <span>基準位置からの距離（上方向、マイナス可）</span>
                      <b-field>
                        <input class="input" type="text" placeholder="距離（上）" v-model="color.pc_offset_up">
                      </b-field>
                    </div>
                    <div class="column">
                      <span>基準位置からの距離（左方向、マイナス可）</span>
                      <b-field>
                        <input class="input" type="text" placeholder="距離（左）" v-model="color.pc_offset_left">
                      </b-field>
                    </div>
                  </div>
                </section>
                <section>
                  <p><b>モバイル設定</b></p>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <span>アプリ　設置アイコンの基準位置（縦）</span>
                      <b-select placeholder="位置を選択"
                                v-model="color.mobile_vertical_position"
                                expanded>
                          <option
                              v-for="(pos, index) in verticalPositions"
                              :value="pos.label"
                              :key="index">
                              {{ pos.name }}
                          </option>
                      </b-select>
                    </div>
                    <div class="column">
                      <span>アプリ　設置アイコンの基準位置（横）</span>
                      <b-select placeholder="位置を選択"
                                v-model="color.mobile_horizontal_position"
                                expanded>
                          <option
                              v-for="(pos, index) in horizontalPositions"
                              :value="pos.label"
                              :key="index">
                              {{ pos.name }}
                          </option>
                      </b-select>
                    </div>
                  </div>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <span>基準位置からの距離（上方向、マイナス可）</span>
                      <b-field>
                        <input class="input" type="text" placeholder="距離（上）" v-model="color.mobile_offset_up">
                      </b-field>
                    </div>
                    <div class="column">
                      <span>基準位置からの距離（左方向、マイナス可）</span>
                      <b-field>
                        <input class="input" type="text" placeholder="距離（左）" v-model="color.mobile_offset_left">
                      </b-field>
                    </div>
                  </div>
                </section>
                <section>
                  <p><b>入力フォーム</b></p>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <span>入力フォーム</span>
                      <b-field>
                        <b-select placeholder="設定"
                                v-model="color.inputType"
                                expanded>
                          <option
                              v-for="(i, index) in inputName"
                              :value="index"
                              :key="index">
                              {{ i }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                    <div class="column">
                      <span>応募ヘッダー設定</span>
                      <b-field>
                        <b-select placeholder="設定"
                                v-model="color.headerType"
                                expanded>
                          <option
                              v-for="(i, index) in headerName"
                              :value="index"
                              :key="index">
                              {{ i }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                    <div class="column">
                      <span>メッセージ読み込み速度設定</span>
                      <b-field style="flex-wrap: wrap;">
                        <input class="slider -reverse" type="range" max="2" min="0.5" step="0.1" v-model="color.thinking_rate"/>
                        <div style="display: flex; justify-content: space-between; width: 100%;">
                          <p>遅い</p>
                          <p>普通</p>
                          <p>速い</p>
                        </div>
                      </b-field>
                    </div>
                  </div>
                </section>
                <section>
                  <p><b>ロボパレット設定</b></p>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <span>「スタッフと直接会話する」ロボの表示・非表示</span>
                      <b-field>
                        <b-select
                                v-model="color.staffbotType"
                                expanded>
                          <option
                              v-for="(i, index) in staffbotFlg"
                              :value="index"
                              :key="index">
                              {{ i }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                    <div class="column">
                      <span>フッターのカテゴリーメニューの表示・非表示</span>
                      <b-field>
                        <b-select
                                v-model="color.categorymenuType"
                                expanded>
                          <option
                              v-for="(i, index) in categorymenuFlg"
                              :value="index"
                              :key="index">
                              {{ i }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                  </div>
                </section>
                <section v-if="false">
                  <p class="setting-title"><b>会話履歴保存設定</b></p>
                  <div class="columns is-mobile is-centered">
                    <div class="column">
                      <span>求職者様が会話履歴を保持できるかどうかの設定</span>
                      <b-field>
                        <b-select v-model="color.register_icon_type" expanded>
                          <option
                              v-for="(i, index) in headerName"
                              :value="index"
                              :key="index">
                              {{ i }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                  </div>
                </section>
              </article>
            </div>
            <footer class="card-footer" style="border-bottom: 1px solid #dbdbdb;">
              <a class="card-footer-item decision-btn" @click="changeColor" v-if="user.permission===0">反映</a>
              <a class="card-footer-item" v-if="user.permission!==0">管理者権限が必要です</a>
            </footer>
          </div>
        </div>
      </b-tab-item>
      <!-- タブ３：　表示種類の設定 -->
      <b-tab-item>
        <template slot="header" class="header">
            <span class="mdi mdi-contacts mdi-24px" style="margin-left:5px;"></span>
            <span> アプリ 表示種類の設定 </span>
        </template>
        <div class="block-container disp-scroll">
          <div class="card-disp-tab -display">
            <header class="card-header">
              <div class="card-header-title">
                HRモンスター | アプリ 表示種類の設定
              </div>
            </header>
            <div class="media-content" style="display: flex; justify-content: center; padding: 15px;">
              <img style="width: 256px;" :src="makeView()"/>
            </div>
            <div class="card-content" style="background: #FEFEFE; word-wrap: break-word;">
              <b-field label="表示種類" style="margin-top: 30px; margin-bottom: 20px; color: white; text-align: left;">
                <b-select v-model="color.view_template" expanded>
                  <option
                    style="font-size: 12px;"
                    v-for="(view, index) in viewList"
                    :value="view.index"
                    :key="index">
                    {{ view.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <footer class="card-footer" style="border-bottom: 1px solid #dbdbdb;">
              <a class="card-footer-item decision-btn" @click="changeColor" v-if="user.permission===0">反映</a>
              <a class="card-footer-item" v-if="user.permission!==0">管理者権限が必要です</a>
            </footer>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import hex2rgb from '@/functions/hex2rgb'
import getIcon from '@/functions/getIcon'
import getAnimation from '@/functions/getAnimation'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'AppIconSetting',
  componentName: 'AppIconSetting',
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      isUploaded: false,
      filename: '',
      uploadedImage: '',
      file: null,
      isCommonPage: true,
      isFavoritePage: false,
      iconSelectFlg: false,
      template: 0,
      croppa: null,
      selectedType: [],
      selectedNum: [],
      buttonMD: [],
      buttonCL: [],
      buttonColors: [
        'White',
        'Blue',
        'Yellow',
        'Red'
      ],
      shapeName: [
        '四角',
        '丸',
        'カスタム'
      ],
      shadowName: [
        'なし',
        'あり'
      ],
      inputName: [
        'なし',
        'あり'
      ],
      headerName: [
        'なし',
        'あり'
      ],
      staffbotFlg: [
        '表示',
        '非表示'
      ],
      categorymenuFlg: [
        '表示',
        '非表示'
      ],
      animationType: [
        'なし',
        '波紋',
        '上下に浮遊',
        '回転',
        '拡大・縮小'
      ],
      viewTemplate: 0,
      viewList: [
        {
          index: 3,
          name: 'スタンダード'
        },
        {
          index: 0,
          name: 'アイコン一覧表現'
        },
        {
          index: 2,
          name: '選択表現なし'
        },
      ],
      iconWidth: '',
      iconHeight: '',
      iconRadius: '',
      showStates: [
        {name: '表示', label: true},
        {name: '非表示', label: false}
      ],
      verticalPositions: [
        {name: '上', label: 'top'},
        {name: '中央', label: 'center'},
        {name: '下', label: "bottom"}
      ],
      horizontalPositions: [
        {name: '左', label: 'left'},
        {name: '中央', label: 'center'},
        {name: '右', label: 'right'}
      ],
    }
  },
  watch: {
    ['color.shapeType'] () {
      if (this.color.shapeType == 0) {
        this.$store.dispatch('auth/changeShape', {customMsg: '', iconHeight: '80', iconWidth: '80', iconRadius: '4'})
      } else if (this.color.shapeType == 1) {
        this.$store.dispatch('auth/changeShape', {customMsg: '', iconHeight: '80', iconWidth: '80', iconRadius: '120'})
      } else if (this.color.shapeType == 2) {
        this.setCustomInfo()
      }
    },
    iconHeight () {
      this.$store.dispatch('auth/changeIconHeight', this.iconHeight)
    },
    iconWidth () {
      this.$store.dispatch('auth/changeIconWidth', this.iconWidth)
    },
    iconRadius () {
      this.$store.dispatch('auth/changeIconRadius', this.iconRadius)
    }
  },
  computed: {
    ...mapState('auth', ['user', 'snippets', 'color', 'success', 'error', 'power', 'isLoading', 'message']),
  },
  mounted () {
    this.setCustomInfo ()
  },
  methods: {
    setCustomInfo () {
      this.iconWidth = this.color.iconWidth.replace('px', '')
      this.iconHeight = this.color.iconHeight.replace('px', '')
      this.iconRadius = this.color.iconRadius.replace('px', '')
    },
    isVideo () {
      return localStorage.getItem('IS_VIDEO_FLG')
    },
    setProfile (data, type) {
      this.$store.dispatch('auth/setProfile', {data: data, type: type})
        .then(() => { if (this.error) { this.errorBar(this.error) } })
        .then(() => { if (!this.error) { this.successBar() } })
    },
    errorBar (e) {
      console.debug('*** Start *** errorBar')
      console.error('e: ' + JSON.stringify(e))
      this.$buefy.snackbar.open({
        message: '正常に保存が完了しませんでした。再読み込みしてください。',
        type: 'is-danger',
        position: 'is-top'
      })
      console.debug('*** End *** errorBar')
    },
    successBar () {
      console.debug('*** Start *** successBar')
      this.$buefy.snackbar.open({
        message: 'セーブしました！',
        type: 'is-success',
        position: 'is-top'
      })
      console.debug('*** End *** successBar')
    },
    makeView () {
      return require('@/assets/template/select_0' + (this.color.view_template + 1) + '.svg')
    },
    onFileTypeMismatch (file) {
      alert('jpg, gif, png, svg　形式でアップして下さい。')
    },
    onFileSizeExceed (file) {
      alert('ファイルは10MB以下でアップロードして下さい。')
    },
    makeIconSelect () {
      return {
        'box-shadow': '2px 2px 5px rgba(0, 0, 0, 0.2)',
        'background-color': this.color.iconBg,
        color: this.color.iconFr
      }
    },
    getIcon (i) {
      return getIcon(i)
    },
    getAnimation (i) {
      return getAnimation(i)
    },
    clipcopy () {
      let codeToCopy = document.querySelector('#copy-code')
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()
      try {
        var successful = document.execCommand('copy')
        if (successful) {
          console.info('success')
          this.$buefy.toast.open({
            message: 'クリップボードにコピーしました。',
            type: 'is-success'
          })
        } else {
          console.error('error')
          this.$buefy.toast.open({
            message: 'クリップボードにコピーできませんでした。',
            type: 'is-danger'
          })
        }
      } catch (err) {
          console.error('err: ' + JSON.stringify(err))
          alert('Oops, unable to copy')
      }
      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
      console.debug('*** End *** clipcopy')
    },
    changeColor (){
      this.sendControlLog('アプリアイコン設定　変更', 'アプリアイコン画面にて、「反映」ボタンをクリックした。')
      console.debug('*** Start *** changeColor')
      if (!this.color.pc_offset_up) this.color.pc_offset_up = 0
      if (!this.color.pc_offset_left) this.color.pc_offset_left = 0
      if (!this.color.mobile_offset_up) this.color.mobile_offset_up = 0
      if (!this.color.mobile_offset_left) this.color.mobile_offset_left = 0
      this.$store.dispatch('auth/setColor', this.color)
      console.debug('*** End *** changeColor')
    },
    errorBar (e) {
      console.debug('*** Start *** errorBar')
      console.error('e: ' + JSON.stringify(e))
      this.$buefy.snackbar.open({
        message: '正常に保存が完了しませんでした。',
        type: 'is-danger',
        position: 'is-top'
      })
      console.debug('*** End *** errorBar')
    },
    successBar () {
      console.debug('*** Start *** successBar')
      this.$buefy.snackbar.open({
        message: 'セーブしました！',
        type: 'is-success',
        position: 'is-top'
      })
      console.debug('*** End *** successBar')
    },
    changeSwitch () {
      console.debug('*** Start *** changeSwitch')
      this.$store.dispatch('auth/setPower', !(this.power === 1))
      console.debug('*** End *** changeSwitch')
    },
    shadowStyle () {
      console.debug('*** Start *** shadowStyle')
      if (this.color.shadowType === 0) return 'drop-shadow(0px 0px 0px rgba(0,0,0,0.6))'
      else return 'drop-shadow(1px 1px 1px rgba(0,0,0,0.6))'
    },
    autoColor (c) {
      var color = hex2rgb(c)
      var cl = '#000'
      if ((color[0] * 0.299 + color[1] * 0.587 + color[2] * 0.114) < 206) {
        cl = '#FFF'
      }
      return cl
    },
    onFileChange (e) {
      console.debug('*** Start *** autoColor')
      console.error('e: ' + JSON.stringify(e))
      let files = e.target.files || e.dataTransfer.files
      this.filename = files[0].name
      let reader = new FileReader()
      reader.onload = (e) => {
        this.color.template = 10
        this.$store.dispatch('auth/setIconImage', {name: this.filename, data: e.target.result})
        // 同じ画像をアップロードするとき、@changeが効かなくなるのでvalueを消す
        this.$refs.imageUploader.value = ''
      }
      reader.readAsDataURL(files[0])
      console.debug('*** End *** autoColor')
    }
  }
}
</script>

<style lang="scss" scoped>
b {
  font-size: medium;
}
.card {
  height: calc(100vh - 190px);
  font-size: smaller;
}
.card-add-tab {
  height: 60vh;
  font-size: smaller;
}
.card-setting-tab {
  height: calc(100vh - 190px);
  font-size: smaller;
}
.card-disp-tab {
  height: 60vh;
  font-size: smaller;
}
.card-header-title {
  font-size: medium;
}
.tab-container {
  margin: 0;
  width: 100%;
  height: 100vh;
}
.flex{
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.block-container {
  height: 100vh;
  width: 100%;
  padding: 20px;
  flex-flow: column nowrap;
  .card {
    border-radius: 5px;
    &.-display {
      width: 500px;
    }
  }
  // 小さいウィンドウだと反映ボタンが消えるので100px余裕を持たせる
  &.-icon-setting {
    padding-bottom: 100px;
  }
}

.edit-field{
  padding: 20px;
  background: #FEFEFE;
}

h1 {
  font-weight: 700;
  font-size: 18px;
}
.blank {
  width: 150px;
}
.list-card {
  max-width: 30vw;
  min-height: 50vh;
  padding: 10px;
}
.inner-card {
  padding: 25px;
  margin: 10px;
  max-width: 30vw;
}
.add-box {
  margin-top: 15px;
  width: 65vw;
  height: auto;
  padding: 20px;
  line-height: 15px;
  border: solid thin #ccc;
}
.custom-label {
  padding-left: 10px !important;
  padding-right: 20px !important;
}
.tabs-common-setting {
  margin-bottom: 7px;
  padding: 7px;
}
.snippets {
  text-align: left;
}
.icon {
  width: 60px;
  height: 60px;
}
.icon > img {
  display: block;
  object-fit: cover;
}
.balloon {
  width: 180px;
  height: 80px;
  padding: 18px;
  color: white;
  border-radius: 15px;
}
.icon-style {
  position: relative;
  &.-ballon {
    height: auto;
  }
}
.icon-modify {
  bottom: 0;
  right: -30px;
  a {
    margin-top: 20px;
    width: 100%;
  }
  input {
    display: none;
  }
}
.bot-icon {
  transform: scale(0.8);
  position: relative;
}
.minimize-button {
  position: absolute;
  top: -8px;
  right: -4px;
  width: 36px;
  z-index: 9999;
  text-align: center;
}
.list-msg {
  width: 150px;
  margin-bottom:5px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 0;
}
.new-msg-log{
  padding: 7px;
  font-size: 11px;
}
.decision-btn, .copy-btn {
  font-weight: bold;
  font-size: medium;
}
.custom-icon-message {
  font-size: large;
  white-space: pre-wrap;
  &.-custom-true{
    position: absolute;
  }
  span {
    font-weight: bold;
  }
}
.left-4px {
  margin-left: 4px;
}
.icon-demo-container {
  height: auto;
}
.icon-demo-wrapper {
  width: 320px;
  background: #fff;
  padding: 32px 8px;
  border-radius: 4px;
  position: sticky;
  top: 0;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  height: fit-content;
  height: 100%;
}
.icon-demo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
}
.right-balloon-wrapper {
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
}
.left-balloon-wrapper {
  display: flex;
  justify-content: center;
}
.setting-article {
  padding: 16px;
  margin-left: 16px;
  flex-flow: column nowrap;
  width: 100%;
  section:not(:last-child) {
    margin-bottom: 40px;
  }
}
.card-content {
  &.-icon-setting {
    background: #FEFEFE;
    word-wrap: break-word;
    display: flex;
    height: 70vh;
  }
}
.select-icon-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}
.columns:not(:last-child) {
  margin-bottom: 0;
}
.icon-select-btn {
  width: 100%;
}
.slider {
  width: 100%;
  margin-top: 5px;
  background: rgba(200, 200, 200, 0.6) !important;
  .-reverse {
    transform: rotateZ(180deg);
  }
}
.custom-columns {
  align-items: center;
}

// * アニメーションについて、表示の都合上、全てscale0.8をつける必要あり
/* 波紋 */
.back-ring {
  position: absolute;
  animation: pulsate 1s ease-out;
  animation-iteration-count: infinite;
  z-index: 0;
}
@keyframes pulsate {
  0%   { filter: brightness(120%); transform: scale(0.8); opacity: 0.8;}
  50%  { filter: brightness(150%); opacity: 0.8; }
  100% { filter: brightness(180%); transform: scale(1); opacity: 0.0; }
}

/* 上下に浮遊 */
.huyuu {
  height: 60px;
  width: 60px;
  animation: huwahuwa 2s ease-out;
  animation-iteration-count: infinite;
  z-index: 0;
}
@keyframes huwahuwa {
  0% {
    transform: translateY(0px) scale(0.8);
  }
  50% {
    transform: translateY(-7.5px) scale(0.8);
  }
  100% {
    transform: translateY(0px) scale(0.8);
  }
}

/* ぐるぐる */
.guruguru {
  height: 60px;
  width: 60px;
  animation: guruguru 3s ease-out;
  animation-iteration-count: infinite;
  z-index: 0;
}
@keyframes guruguru {
  0% {
    transform: rotateY(0deg) scale(0.8);
  }
  50% {
    transform: rotateY(180deg) scale(0.8);
  }
  100% {
    transform: rotateY(360deg) scale(0.8);
  }
}

/* 拡大・縮小 */
.kakusyuku {
  height: 60px;
  width: 60px;
  animation: kakusyuku 3s ease-out;
  animation-iteration-count: infinite;
  z-index: 0;
}
@keyframes kakusyuku {
  0% {
    transform: scale(1.0) scale(0.8);
  }
  50% {
    transform: scale(0.85) scale(0.8);
  }
  100% {
    transform: scale(1.0) scale(0.8);
  }
}
.message-icon{
  display: inline-block;
  font-size: 12px;
  text-align: left;
  padding: 4px;
  font-weight: bold;
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/AppIconSetting.vue